import { render, staticRenderFns } from "./DanSelect.vue?vue&type=template&id=22d0224d&scoped=true"
import script from "./DanSelect.vue?vue&type=script&lang=js"
export * from "./DanSelect.vue?vue&type=script&lang=js"
import style0 from "./DanSelect.vue?vue&type=style&index=0&id=22d0224d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d0224d",
  null
  
)

export default component.exports